import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface FloorProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function Floor(props: FloorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Floor"
      width={975}
      height={438}
      viewBox="0 0 975 438"
      position={{top: 32, left: 357}}
    >
      <path
        d="M1 251.988C1 336.757 23.6667 402.266 35 423.925C40 424.924 54 425.924 68 423.925C69.2643 426.757 74.2439 432.943 85 434.921H84.9898C109.982 438.919 263.074 435.92 334.911 435.92H360.902L361 435.92H385L661.937 434.921H661.941C723.294 434.753 852.2 433.118 877 427.921V427.923C904.013 422.337 912.633 410.956 919 398.934C921.101 394.967 924.259 389.878 928 382.94C931.112 381.508 933.861 379.652 936 377.942C943.202 372.182 954.997 362.109 961 345.953C974 310.965 974 253.042 974 219.048V219V218.952C974 184.958 974 127.035 961 92.0466C954.997 75.8905 943.202 65.8182 936 60.0583C933.861 58.3481 931.112 56.4915 928 55.0602C924.259 48.1217 921.101 43.0332 919 39.066C912.633 27.0435 904.013 15.6634 877 10.0766V10.0787C852.2 4.88232 723.294 3.24716 661.941 3.07916L661.937 3.07922L385 2.0798H361L360.902 2.07959H334.911C263.074 2.07959 109.982 -0.919312 84.9898 3.07922H85C74.2439 5.05664 69.2643 11.243 68 14.0752C54 12.0759 40 13.0757 35 14.0753C23.6667 35.734 1 101.243 1 186.012L1 219L1 251.988Z"
        fill="currentColor"
        className={baseFill()}
      ></path>
      <path
        d="M1 251.988C1 336.757 23.6667 402.266 35 423.925C40 424.924 54 425.924 68 423.925C69.2643 426.757 74.2439 432.943 85 434.921H84.9898C109.982 438.919 263.074 435.92 334.911 435.92H360.902L361 435.92H385L661.937 434.921H661.941C723.294 434.753 852.2 433.118 877 427.921V427.923C904.013 422.337 912.633 410.956 919 398.934C921.101 394.967 924.259 389.878 928 382.94C931.112 381.508 933.861 379.652 936 377.942C943.202 372.182 954.997 362.109 961 345.953C974 310.965 974 253.042 974 219.048V219V218.952C974 184.958 974 127.035 961 92.0466C954.997 75.8905 943.202 65.8182 936 60.0583C933.861 58.3481 931.112 56.4915 928 55.0602C924.259 48.1217 921.101 43.0332 919 39.066C912.633 27.0435 904.013 15.6634 877 10.0766V10.0787C852.2 4.88232 723.294 3.24716 661.941 3.07916L661.937 3.07922L385 2.0798H361L360.902 2.07959H334.911C263.074 2.07959 109.982 -0.919312 84.9898 3.07922H85C74.2439 5.05664 69.2643 11.243 68 14.0752C54 12.0759 40 13.0757 35 14.0753C23.6667 35.734 1 101.243 1 186.012L1 219L1 251.988Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
    </PartSvg>
  );
}
